var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Quantity, RediError, } from '@wendellhu/redi';
var ClassComponentNotInRediContextError = /** @class */ (function (_super) {
    __extends(ClassComponentNotInRediContextError, _super);
    function ClassComponentNotInRediContextError(component) {
        return _super.call(this, "You should make \"RediContext\" as ".concat(component.constructor.name, "'s default context type. ")
            + 'If you want to use multiple context, please check this on React doc site. '
            + 'https://reactjs.org/docs/context.html#classcontexttype') || this;
    }
    return ClassComponentNotInRediContextError;
}(RediError));
export function WithDependency(id, quantity, lookUp) {
    return function () {
        return {
            get: function () {
                var thisComponent = this;
                var context = thisComponent.context;
                if (!context || !context.injector) {
                    throw new ClassComponentNotInRediContextError(thisComponent);
                }
                var injector = context.injector;
                var thing = injector.get(id, quantity || Quantity.REQUIRED, lookUp);
                return thing;
            },
        };
    };
}
//# sourceMappingURL=reactDecorators.js.map